<template>
    <div>
        <span class="text">
            <div><b>{{ question.title }}</b> - {{ question.question }}</div>
            <div class="question-subpart">
                <div v-if="question.type === 'multi_question' || question.type === 'text'" class="search-text">
                    <el-input placeholder="Search" v-model="contain" clearable></el-input>
                </div>
                <div v-else-if="question.type === 'unit'" class="search-unit">
                    More than
                    <el-input type="number" :controls="false" size="small" v-model.number="minValue"></el-input>
                    and Less than
                    <el-input type="number" :controls="false" size="small" v-model.number="maxValue"></el-input>
                    &nbsp;
                </div>
                <div v-else-if="question.type === 'date'" class="search-date">
                    More than
                    <el-date-picker type="date" :controls="false" size="small" value-format="timestamp" v-model="minValue"></el-date-picker>
                    and Less than
                    <el-date-picker type="date" :controls="false" size="small" value-format="timestamp" v-model.number="maxValue"></el-date-picker>
                    &nbsp;
                </div>
                <div v-if="countProblems && countProblems.total !== 0" :class="{ solved: countProblems.total === countProblems.solved }">
                    {{countProblems.solved}} of {{countProblems.total}} flags resolved
                </div>
            </div>
        </span>
        <div v-if="['image_upload', 'human_map'].includes(question.type)">
            <h4 style="padding: 20px">N/A</h4>
        </div>
        <MultiAnalysis 
            v-else-if="question.type === 'multi_question'"
            :question="question"
            :contain="contain">
        </MultiAnalysis>
        <VerticalAnalysis
            v-else
            :question="question"
            :contain="contain"
            :minValue="minValue"
            :maxValue="maxValue">
        </VerticalAnalysis>
    </div>
</template>

<script>

import VerticalAnalysis from './analysis/Vertical'
import MultiAnalysis from './analysis/Multi'

export default {
    name: 'question-viewer',

    data() {
        return {
            contain: '',
            minValue: undefined,
            maxValue: undefined,
        }
    },

    props: {
        question: {
            type: Object
        }
    },

    methods: {
        changeInput() {
            console.log('change')
        }
    },

    computed: {
        countProblems() {
            const userList = (this.question.answer ? this.question.answer : []).flatMap(({ user }) => user) || []
            const problemList = userList.flatMap((user) => user ? (user.problem ? user.problem.filter(({question_id}) => question_id === this.question.id) : []) : [])
            if(Array.isArray(problemList) && problemList.length > 0)
                return {
                    total: problemList.length,
                    solved: problemList.filter((problem) => problem.resolved_time).length
                }
            return null
        }
    },

    components: {
        VerticalAnalysis,
        MultiAnalysis
    }
}
</script>

<style lang="scss" scoped>
.text {
    width: 100%;
    padding-left: 60px;
    padding-right: 5px;
    background-color: #eeeeee;
    color: #7f7f7f;
    font-size: 16px;
    line-height: 36px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    b {
        color: #333;
    }

    span {
        float: left;
        background-color: #833e93;
        height: 36px;
        color: #fff;
        padding: 0 15px;
        margin-right: 15px;
        
    }
    .question-subpart>div{
        display: inline-block;
    }

    .search-unit {
        .el-input {
            width: 50px;
        }
    }
    .search-date {
        min-width: 500px;
        .el-date-editor {
            width: 150px;
        }
    }
    .solved {
        color: #44B358;
    }
}
</style>

<style>
.text .search-unit input {
    padding: 5px;
}
.text .search-unit input[type=number]::-webkit-inner-spin-button, 
.text .search-unit input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
</style>